import { Component } from '@angular/core';
import { DGoodsButtonComponent } from './dgoods-button.component';

@Component({
    selector: 'dgoods-back-button',
    templateUrl: './dgoods-back-button.component.html',
    styleUrls: ['./dgoods-back-button.component.scss'],
})
export class DGoodsBackButtonComponent extends DGoodsButtonComponent {}
